// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xk_a bhh_a bhh_x","StrollerDetailRating__muted":"xk_b bhh_fm"};